import React from 'react';
import PropTypes from 'prop-types';

const Underline = ({ children }) => <u>{children}</u>;

Underline.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Underline;
